import React, { useState, useEffect } from 'react';
import logo from '../images/logo.png';

function NavbarComponent() {
    const [isNavbarFixed, setIsNavbarFixed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleScroll = () => {
            setIsNavbarFixed(window.scrollY > 0);
        };
        const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const navHeight = isMobile ? '70px' : isNavbarFixed ? '70px' : '150px';
    const logoHeight = isMobile ? '55px' : isNavbarFixed ? '70px' : '150px';

    return (
        <nav
            className={`navbar navbar-expand-lg ${
                isNavbarFixed ? 'grayBackground fixed-top' : 'bg-transparent'
            }`}
            style={{
                height: navHeight,
                transition: 'height 0.3s ease',
            }}
        >
            <div className="container-fluid">
                {/* Logo Section */}
                <a className="navbar-brand" href="/" aria-label="Mehandi Malabar – Home">
                    <img
                        src={logo}
                        alt="Mehandi Malabar logo"
                        style={{
                            height: logoHeight,
                            transition: 'height 0.3s ease',
                        }}
                    />
                </a>

                {/* Navbar Toggler for Mobile */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Navbar Links */}
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    isNavbarFixed || isMobile ? 'text-dark' : 'text-light'
                                }`}
                                href="/"
                            >
                                Home
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    isNavbarFixed || isMobile ? 'text-dark' : 'text-light'
                                }`}
                                href="/about"
                            >
                                Meet Our Artist
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    isNavbarFixed || isMobile ? 'text-dark' : 'text-light'
                                }`}
                                href="/gallery"
                            >
                                Gallery
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={`nav-link ${
                                    isNavbarFixed || isMobile ? 'text-dark' : 'text-light'
                                }`}
                                href="/contact"
                            >
                                Contact
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}

export default NavbarComponent;
